module.exports = __webpack_public_path__ + "img/20191207152248324.ce6e40f1.jpg";